package diana.soleil.design.iraniancanadienbazzar.feature.business

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.asPaddingValues
import androidx.compose.foundation.layout.navigationBars
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.rememberScrollState
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.LocalUriHandler
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AccentBadge
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppBottomSheet
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppChip
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppFab
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIconButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.BusinessCover
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.DirectoryBusinessCard
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.EmptyState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ErrorState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.LoadingState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.NearbyBusinessCard
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.categoryImageRes
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.WindowWidthClass
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.windowWidthClassFor
import diana.soleil.design.iraniancanadienbazzar.core.data.LocationController
import diana.soleil.design.iraniancanadienbazzar.core.model.Business
import diana.soleil.design.iraniancanadienbazzar.core.model.DiscoveryRanking
import diana.soleil.design.iraniancanadienbazzar.core.model.GeoPoint
import diana.soleil.design.iraniancanadienbazzar.core.model.categoryIconKey
import diana.soleil.design.iraniancanadienbazzar.core.model.distanceKmFrom
import diana.soleil.design.iraniancanadienbazzar.core.model.openStateAt
import diana.soleil.design.iraniancanadienbazzar.core.model.cityLabel
import diana.soleil.design.iraniancanadienbazzar.core.model.Language
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.Res
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_action_details
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_action_view_menu
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_add_listing_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_back_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_call_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_directions_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_empty
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_badge_new
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_error
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_favorite_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_distance_km
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_distance_m
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_filter_price
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_filter_top_rated
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_filter_verified
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_open_now
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_rating_reviews
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_retry
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_section_nearby
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_section_recommended
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_sponsored
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_verified
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_pro_badge
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_verified_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.report_done
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.search_filters_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.search_sheet_title
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.search_sort_label
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.search_sort_nearest
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.search_sort_recommended
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.koinInject
import org.koin.compose.viewmodel.koinViewModel
import org.koin.core.parameter.parametersOf
import kotlin.math.roundToInt
import kotlin.time.Clock
import kotlin.time.Instant

/**
 * Stateful entry for the business listing: resolves [BusinessListViewModel] (scoped to [categoryId])
 * from Koin and renders the stateless screen. The title comes from the category document once loaded,
 * falling back to [categoryTitle] from the route.
 */
@Composable
fun BusinessListRoute(
    categoryId: String,
    categoryTitle: String,
    onBack: () -> Unit,
    onBusinessClick: (businessId: String) -> Unit,
    modifier: Modifier = Modifier,
    onAddBusiness: () -> Unit = {},
    viewModel: BusinessListViewModel = koinViewModel(parameters = { parametersOf(categoryId) }),
    locationController: LocationController = koinInject(),
) {
    val state by viewModel.state.collectAsStateWithLifecycle()
    val category by viewModel.category.collectAsStateWithLifecycle()
    val favorites by viewModel.favorites.collectAsStateWithLifecycle()
    val userLocation by locationController.location.collectAsStateWithLifecycle()
    // Ask for the user's location once when a directory list is opened — a contextual, expected moment.
    LaunchedEffect(Unit) { locationController.ensureLocation() }
    BusinessListScreen(
        state = state,
        categoryTitle = category?.displayName(AppTheme.language) ?: categoryTitle,
        onBack = onBack,
        onBusinessClick = onBusinessClick,
        onAddBusiness = onAddBusiness,
        onRetry = viewModel::retry,
        userLocation = userLocation,
        favorites = favorites,
        onToggleFavorite = viewModel::toggleFavorite,
        modifier = modifier,
    )
}

/** How the list is re-ordered on top of the default appeal ranking coming from the view model. */
private enum class ListSort { Recommended, Nearest, TopRated }

/** Screen-local view filters. [prices] is the set of selected tiers (1–4); empty = any price. */
private data class ListFilters(
    val sort: ListSort = ListSort.Recommended,
    val verifiedOnly: Boolean = false,
    val openNow: Boolean = false,
    val prices: Set<Int> = emptySet(),
)

/**
 * Business listing — Stitch `19bc25c5` (mobile) / `28584f61` (desktop). Teal top bar with the
 * category title + filters, chips, "Recommended" (sponsored slots) with rich cards, then compact
 * "Nearby Results" cards, and a saffron add-location FAB. Tokens + string resources only.
 */
@Composable
fun BusinessListScreen(
    state: BusinessListUiState,
    categoryTitle: String,
    onBack: () -> Unit,
    onBusinessClick: (businessId: String) -> Unit,
    onRetry: () -> Unit,
    modifier: Modifier = Modifier,
    onAddBusiness: () -> Unit = {},
    userLocation: GeoPoint? = null,
    favorites: Set<String> = emptySet(),
    onToggleFavorite: (String) -> Unit = {},
) {
    var filters by remember { mutableStateOf(ListFilters()) }
    var showFilterSheet by remember { mutableStateOf(false) }

    Box(modifier = modifier.fillMaxSize().background(AppTheme.colors.background)) {
        Column(modifier = Modifier.fillMaxSize()) {
            TopBar(
                title = categoryTitle,
                onBack = onBack,
                onOpenFilters = { showFilterSheet = true },
            )

            if (state.error) {
                ErrorState(
                    message = stringResource(Res.string.business_error),
                    onRetry = onRetry,
                    retryLabel = stringResource(Res.string.business_retry),
                )
                return@Column
            }

            val now = Clock.System.now()
            // "Nearest" measures from the GPS fix when granted, else the metro centre (VM-provided).
            val sponsored = state.sponsored.applyFilters(filters, now, state.origin)
            val nearby = state.nearby.applyFilters(filters, now, state.origin)

            BoxWithConstraints(modifier = Modifier.fillMaxWidth()) {
                // Sponsored cards: single column on phones, two on wider screens; the whole list is
                // centered at a max width so it doesn't stretch on desktop.
                val columns = if (windowWidthClassFor(maxWidth) == WindowWidthClass.Compact) 1 else 2
                LazyColumn(
                    modifier = Modifier
                        .fillMaxHeight()
                        .widthIn(max = AppTheme.sizes.contentMaxWidth)
                        .align(Alignment.TopCenter),
                    contentPadding = PaddingValues(
                        start = AppTheme.spacing.lg,
                        end = AppTheme.spacing.lg,
                        top = AppTheme.spacing.lg,
                        // Clear the add-location FAB + the system navigation bar so the last card's
                        // actions stay tappable (owner bug 2026-07-26: nav bar overlapped content).
                        bottom = AppTheme.spacing.xxxxl + AppTheme.spacing.xl +
                            WindowInsets.navigationBars.asPaddingValues().calculateBottomPadding(),
                    ),
                    verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
                ) {
                    item {
                        FilterChips(filters = filters, onChange = { filters = it })
                    }

                    if (state.loading) {
                        item { LoadingState() }
                    } else if (sponsored.isEmpty() && nearby.isEmpty()) {
                        item { EmptyState(title = stringResource(Res.string.business_empty)) }
                    }

                    if (sponsored.isNotEmpty()) {
                        item {
                            Row(
                                modifier = Modifier.fillMaxWidth().padding(top = AppTheme.spacing.sm),
                                horizontalArrangement = Arrangement.SpaceBetween,
                                verticalAlignment = Alignment.CenterVertically,
                            ) {
                                Text(
                                    text = stringResource(Res.string.business_section_recommended),
                                    style = AppTheme.typography.headlineMd,
                                    color = AppTheme.colors.onSurface,
                                )
                                AccentBadge(label = stringResource(Res.string.business_sponsored))
                            }
                        }
                        items(sponsored.chunked(columns), key = { it.first().id }) { row ->
                            SponsoredCardRow(row, columns, onBusinessClick, userLocation, favorites, onToggleFavorite)
                        }
                    }
                    if (nearby.isNotEmpty()) {
                        item {
                            Text(
                                text = stringResource(Res.string.business_section_nearby),
                                style = AppTheme.typography.headlineMd,
                                color = AppTheme.colors.onSurface,
                                modifier = Modifier.padding(top = AppTheme.spacing.sm),
                            )
                        }
                        items(nearby, key = { it.id }) { business ->
                            NearbyCardItem(business, onBusinessClick, userLocation)
                        }
                    }
                }
            }
        }

        AppFab(
            iconName = "add_location",
            contentDescription = stringResource(Res.string.business_add_listing_a11y),
            onClick = onAddBusiness,
            modifier = Modifier
                .align(Alignment.BottomEnd)
                // Clear the system navigation bar too (QA round-7: the FAB itself still sat under it).
                .navigationBarsPadding()
                .padding(AppTheme.spacing.xl),
        )
    }

    if (showFilterSheet) {
        FilterSheet(
            filters = filters,
            onChange = { filters = it },
            onDismiss = { showFilterSheet = false },
        )
    }
}

/** Teal header (Stitch): back, category title, and the filter (tune) action. */
@Composable
private fun TopBar(title: String, onBack: () -> Unit, onOpenFilters: () -> Unit) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .background(AppTheme.colors.primaryContainer)
            .statusBarsPadding()
            .padding(horizontal = AppTheme.spacing.lg, vertical = AppTheme.spacing.md),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
    ) {
        AppIconButton(
            iconName = "arrow_back",
            contentDescription = stringResource(Res.string.business_back_a11y),
            onClick = onBack,
            tint = AppTheme.colors.onPrimary,
        )
        Text(
            text = title,
            style = AppTheme.typography.headlineMd,
            color = AppTheme.colors.onPrimary,
            modifier = Modifier.weight(1f),
        )
        AppIconButton(
            iconName = "tune",
            contentDescription = stringResource(Res.string.search_filters_a11y),
            onClick = onOpenFilters,
            tint = AppTheme.colors.onPrimary,
        )
    }
}

@Composable
private fun FilterChips(filters: ListFilters, onChange: (ListFilters) -> Unit) {
    Row(
        modifier = Modifier.horizontalScroll(rememberScrollState()),
        horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
    ) {
        AppChip(
            label = stringResource(Res.string.business_open_now),
            selected = filters.openNow,
            leadingIcon = "schedule",
            onClick = { onChange(filters.copy(openNow = !filters.openNow)) },
        )
        SortToggleChip(filters, ListSort.Nearest, stringResource(Res.string.search_sort_nearest), "near_me", onChange)
        SortToggleChip(filters, ListSort.TopRated, stringResource(Res.string.business_filter_top_rated), "star", onChange)
        AppChip(
            label = stringResource(Res.string.business_filter_verified),
            selected = filters.verifiedOnly,
            leadingIcon = "verified",
            onClick = { onChange(filters.copy(verifiedOnly = !filters.verifiedOnly)) },
        )
        PriceChips(filters = filters, onChange = onChange)
    }
}

/** Quick-sort chip: tapping selects that sort, tapping again falls back to Recommended. */
@Composable
private fun SortToggleChip(
    filters: ListFilters,
    sort: ListSort,
    label: String,
    icon: String,
    onChange: (ListFilters) -> Unit,
) {
    AppChip(
        label = label,
        selected = filters.sort == sort,
        leadingIcon = icon,
        onClick = {
            onChange(filters.copy(sort = if (filters.sort == sort) ListSort.Recommended else sort))
        },
    )
}

/** $ … $$$$ toggle chips; selecting tiers narrows the list, none = any price. */
@Composable
private fun PriceChips(filters: ListFilters, onChange: (ListFilters) -> Unit) {
    (1..4).forEach { tier ->
        AppChip(
            label = "$".repeat(tier),
            selected = tier in filters.prices,
            onClick = {
                val next = filters.prices.toMutableSet().apply { if (!add(tier)) remove(tier) }
                onChange(filters.copy(prices = next))
            },
        )
    }
}

@Composable
private fun FilterSheet(filters: ListFilters, onChange: (ListFilters) -> Unit, onDismiss: () -> Unit) {
    AppBottomSheet(
        onDismissRequest = onDismiss,
        title = stringResource(Res.string.search_sheet_title),
    ) {
        Text(
            text = stringResource(Res.string.search_sort_label),
            style = AppTheme.typography.labelMd,
            color = AppTheme.colors.onSurface,
            modifier = Modifier.padding(bottom = AppTheme.spacing.sm),
        )
        Row(
            modifier = Modifier.horizontalScroll(rememberScrollState()),
            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
        ) {
            AppChip(
                label = stringResource(Res.string.search_sort_recommended),
                selected = filters.sort == ListSort.Recommended,
                onClick = { onChange(filters.copy(sort = ListSort.Recommended)) },
            )
            AppChip(
                label = stringResource(Res.string.search_sort_nearest),
                selected = filters.sort == ListSort.Nearest,
                leadingIcon = "near_me",
                onClick = { onChange(filters.copy(sort = ListSort.Nearest)) },
            )
            AppChip(
                label = stringResource(Res.string.business_filter_top_rated),
                selected = filters.sort == ListSort.TopRated,
                leadingIcon = "star",
                onClick = { onChange(filters.copy(sort = ListSort.TopRated)) },
            )
        }
        Row(
            modifier = Modifier
                .horizontalScroll(rememberScrollState())
                .padding(top = AppTheme.spacing.lg),
            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
        ) {
            AppChip(
                label = stringResource(Res.string.business_open_now),
                selected = filters.openNow,
                leadingIcon = "schedule",
                onClick = { onChange(filters.copy(openNow = !filters.openNow)) },
            )
            AppChip(
                label = stringResource(Res.string.business_filter_verified),
                selected = filters.verifiedOnly,
                leadingIcon = "verified",
                onClick = { onChange(filters.copy(verifiedOnly = !filters.verifiedOnly)) },
            )
        }
        Text(
            text = stringResource(Res.string.business_filter_price),
            style = AppTheme.typography.labelMd,
            color = AppTheme.colors.onSurface,
            modifier = Modifier.padding(top = AppTheme.spacing.lg),
        )
        Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
            PriceChips(filters = filters, onChange = onChange)
        }
        AppButton(
            text = stringResource(Res.string.report_done),
            onClick = onDismiss,
            modifier = Modifier.fillMaxWidth().padding(top = AppTheme.spacing.xl),
        )
    }
}

private fun List<Business>.applyFilters(filters: ListFilters, now: Instant, origin: GeoPoint?): List<Business> {
    val visible = asSequence()
        .filter { !filters.verifiedOnly || it.verified }
        .filter { filters.prices.isEmpty() || it.priceLevel in filters.prices }
        // "Open now" excludes listings with no hours (unknown ≠ open).
        .filter { !filters.openNow || it.openStateAt(now)?.isOpen == true }
        .toList()
    return when (filters.sort) {
        // The view model already ranks with the shared appeal comparator (photo → nearby → rating).
        ListSort.Recommended -> visible
        ListSort.Nearest -> visible.sortedWith(DiscoveryRanking.businessNearestComparator(origin))
        ListSort.TopRated ->
            visible.sortedWith(compareByDescending<Business> { it.rating }.thenByDescending { it.reviewCount })
    }
}

@Composable
private fun SponsoredCardRow(
    rowItems: List<Business>,
    columns: Int,
    onBusinessClick: (String) -> Unit,
    userLocation: GeoPoint?,
    favorites: Set<String>,
    onToggleFavorite: (String) -> Unit,
) {
    Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md)) {
        rowItems.forEach { business ->
            Box(modifier = Modifier.weight(1f)) {
                SponsoredCardItem(business, onBusinessClick, userLocation, business.id in favorites, onToggleFavorite)
            }
        }
        repeat(columns - rowItems.size) { Spacer(modifier = Modifier.weight(1f)) }
    }
}

@Composable
private fun SponsoredCardItem(
    business: Business,
    onBusinessClick: (String) -> Unit,
    userLocation: GeoPoint?,
    favorite: Boolean,
    onToggleFavorite: (String) -> Unit,
) {
    val lang = AppTheme.language
    val uriHandler = LocalUriHandler.current
    val openStatus = rememberOpenStatus(business)
    val coverUrl = business.coverUrl?.takeIf { it.isNotBlank() }
    val icon = categoryIconKey(business.categoryId)
    val imageRes = categoryImageRes(business.categoryId)
    DirectoryBusinessCard(
        name = business.displayName(lang),
        category = business.serviceLine(lang),
        rating = business.rating.toFloat(),
        openLabel = openStatus?.label,
        isOpen = openStatus?.isOpen ?: true,
        newLabel = stringResource(Res.string.business_badge_new).takeIf { business.reviewCount == 0 },
        // "View menu" only when ordering is actually on for this business — otherwise an honest "Details".
        primaryActionLabel = stringResource(
            if (business.offersOrdering) Res.string.business_action_view_menu else Res.string.business_action_details,
        ),
        onPrimaryAction = { onBusinessClick(business.id) },
        // Wire the same platform-URI actions as Business Detail; hide when the data is absent.
        onCall = business.phone?.takeIf { it.isNotBlank() }?.let { phone ->
            { uriHandler.openUri("tel:" + phone.filterPhone()) }
        },
        onDirections = business.takeIf { it.showsExactLocation }?.address?.let { address ->
            { uriHandler.openUri(address.mapsUri()) }
        },
        callContentDescription = stringResource(Res.string.business_call_a11y),
        directionsContentDescription = stringResource(Res.string.business_directions_a11y),
        locationLabel = locationLabel(business, userLocation),
        verifiedLabel = if (business.verified) stringResource(Res.string.business_verified) else null,
        verifiedContentDescription = stringResource(Res.string.business_verified_a11y),
        proLabel = if (business.ownerPro) stringResource(Res.string.business_pro_badge) else null,
        favorite = favorite,
        favoriteContentDescription = stringResource(Res.string.business_favorite_a11y),
        onToggleFavorite = { onToggleFavorite(business.id) },
        onClick = { onBusinessClick(business.id) },
        coverIcon = icon,
        coverImageRes = imageRes,
        image = coverUrl?.let { url -> { BusinessCover(imageUrl = url, iconName = icon, placeholderImageRes = imageRes) } },
    )
}

@Composable
private fun NearbyCardItem(business: Business, onBusinessClick: (String) -> Unit, userLocation: GeoPoint?) {
    val lang = AppTheme.language
    val coverUrl = business.coverUrl?.takeIf { it.isNotBlank() }
    val icon = categoryIconKey(business.categoryId)
    val imageRes = categoryImageRes(business.categoryId)
    val status = rememberOpenStatus(business)
    NearbyBusinessCard(
        name = business.displayName(lang),
        category = business.serviceLine(lang),
        ratingLine = if (business.reviewCount == 0) {
            stringResource(Res.string.business_badge_new)
        } else {
            stringResource(
                Res.string.business_rating_reviews,
                ratingText(business.rating),
                business.reviewCount,
            )
        },
        locationLabel = locationLabel(business, userLocation).orEmpty(),
        detailsLabel = stringResource(Res.string.business_action_details),
        onDetails = { onBusinessClick(business.id) },
        onClick = { onBusinessClick(business.id) },
        coverIcon = icon,
        coverImageRes = imageRes,
        statusLabel = status?.label,
        statusIsOpen = status?.isOpen ?: true,
        statusDetail = status?.detail,
        image = coverUrl?.let { url -> { BusinessCover(imageUrl = url, iconName = icon, placeholderImageRes = imageRes) } },
    )
}

/** "City, ON" display line; null when the address has no usable parts. */
private fun Business.cityLine(lang: Language): String? =
    listOf(lang.cityLabel(address.city), address.province)
        .filter { it.isNotBlank() }
        .joinToString(", ")
        .takeIf { it.isNotBlank() }

/** City line augmented with "· 2.4 km" when the user's location is known and the business is geocoded. */
@Composable
private fun locationLabel(business: Business, userLocation: GeoPoint?): String? {
    val city = business.cityLine(AppTheme.language)
    val km = userLocation?.let { business.distanceKmFrom(it) } ?: return city
    return listOfNotNull(city, formatDistance(km)).joinToString(" · ").takeIf { it.isNotBlank() }
}

/** "2.4 km" / "850 m", localized. Sub-kilometre distances read in metres. */
@Composable
private fun formatDistance(km: Double): String =
    if (km < 1.0) {
        stringResource(Res.string.business_distance_m, (km * 1000).roundToInt().toString())
    } else {
        val tenths = (km * 10).roundToInt()
        val value = if (tenths % 10 == 0) "${tenths / 10}" else "${tenths / 10}.${tenths % 10}"
        stringResource(Res.string.business_distance_km, value)
    }

/** One-decimal display value for a rating (e.g. 4.75 → "4.8"). */
private fun ratingText(rating: Double): String {
    val rounded = (rating * 10).roundToInt()
    return "${rounded / 10}.${rounded % 10}"
}
